import { render } from "./ConsensusReport.vue?vue&type=template&id=59f36aa8&scoped=true"
import script from "./ConsensusReport.vue?vue&type=script&lang=js"
export * from "./ConsensusReport.vue?vue&type=script&lang=js"

import "./ConsensusReport.vue?vue&type=style&index=0&id=59f36aa8&scoped=true&lang=css"

import exportComponent from "/Users/antoniomarrazzo/Janus - Pasar/janus-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59f36aa8"]])

export default __exports__